import { transport } from 'config/transport';

export function callApiDeleteOffOneMonthForStudent(classId, studentId, month) {
    return transport.del(`/mamnon/classes/${classId}/offonemonth/students/${studentId}`, { params: { month } });
}
